import { lazy } from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';

/**
 * The Settings routes, under `/settings`. The capability gate is in front of
 * the whole subtree in `@app/routes`; this file only lays the pages out.
 * Regions, Preferences, Formats and Rules are four sections of one page, so
 * each route opens it scrolled to its section.
 */

const SettingsLayout = lazy(() => import('./SettingsLayout'));
const FeatureFlagsSettingsPage = lazy(() => import('./pages/FeatureFlagsSettingsPage'));
const FormatsRulesPage = lazy(() => import('./pages/FormatsRulesPage'));

export const settingsRoutes: RouteObject[] = [
  {
    element: <SettingsLayout />,
    children: [
      { index: true, element: <Navigate to="/settings/feature-flags" replace /> },
      { path: 'feature-flags', element: <FeatureFlagsSettingsPage /> },
      { path: 'regions', element: <FormatsRulesPage section="regions" /> },
      { path: 'preferences', element: <FormatsRulesPage section="preferences" /> },
      { path: 'formats', element: <FormatsRulesPage section="formats" /> },
      { path: 'rules', element: <FormatsRulesPage section="rules" /> }
    ]
  }
];
